import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import { authentication } from '@perpay-web/authentication/singleton';
import {
    analyticsPartnerHostedOnboardingVerificationModalPasswordSubmitClicked,
    analyticsPartnerHostedOnboardingVerificationModalPasswordViewed,
} from '@perpay-web/fintech/actions/analytics/partnerHostedOnboarding';
import CardApplicationDirectDepositSuccess from '@perpay-web/fintech/components/composite/CardApplicationDirectDepositSuccess/CardApplicationDirectDepositSuccess';
import {
    fetchDeductionsDataModule,
    getRecentDeductionAmount,
} from '@perpay-web/fintech/dataModules/fetchDeductions';
import { createPasswordDataModule } from '@perpay-web/fintech/dataModules/partnerOnboardingCreatePassword';
import { paths } from '@perpay-web/fintech/props/appPaths';

const CardApplicationDirectDepositSuccessContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const amount = useSelector(getRecentDeductionAmount) || 300;
    const isLoading = useSelector(
        fetchDeductionsDataModule.getIsLoadingOrUnrequested,
    );
    const passwordErrors = useSelector(createPasswordDataModule.getErrors);
    const missingRequirements = authentication.getSignupRequirements();
    const needsPassword = missingRequirements.includes('password_set');

    const partnerCode = authentication.getPartnerOnboardedCode();
    const location = useLocation();

    const onMount = useCallback(() => {
        dispatch(fetchDeductionsDataModule.dataRequest());

        dispatch(
            analyticsPartnerHostedOnboardingVerificationModalPasswordViewed({
                partner: partnerCode,
                path: location.pathname,
                entryPoint: 'card-application-direct-deposit-success',
            }),
        );
    }, [dispatch, partnerCode, location.pathname]);

    const onSubmitPassword = useCallback(
        (value) => {
            dispatch(
                analyticsPartnerHostedOnboardingVerificationModalPasswordSubmitClicked(
                    {
                        partner: partnerCode,
                        path: location.pathname,
                        entryPoint: 'card-application-direct-deposit-success',
                    },
                ),
            );
            dispatch(
                createPasswordDataModule.dataRequest({
                    password: value,
                    dashboardRedirect: true,
                }),
            );
        },
        [dispatch, partnerCode, location.pathname],
    );

    return (
        <CardApplicationDirectDepositSuccess
            onMount={onMount}
            amount={amount}
            isLoading={isLoading}
            onSubmitPassword={onSubmitPassword}
            onSubmitPasswordErrors={passwordErrors}
            onClickBackToDashboard={() => navigate(paths.dashboard.path)}
            needsPassword={needsPassword}
        />
    );
};

export default CardApplicationDirectDepositSuccessContainer;
